import WithPermission from 'Components/SharedComponents/WithPermission/WithPermission'
import { SelfServe } from './SelfServe'
import { SelfServeWidgets } from './SelfServeWidgets'
import { FunderSharedGoals } from './FunderSharedGoals/FunderSharedGoals'
import { ImpactReport } from './ImpactReport/ImpactReport'
import ImpactReportDashboard from '../Impact/ImpactReportDashboard/ImpactReportDashboard'
import { FunderReport } from './FunderReport/FunderReport'
import { NeedsAssessmentTrigger } from './NeedsAssessmentTrigger/NeedsAssessmentTrigger'
import { CheckInSurvey } from '../CheckInSurvey/CheckInSurvey'
import { GoalsWizard } from './GoalsWizard/GoalsWizard'
import { Impersonate } from './Impersonate/Impersonate'
import { CoachingEventPage } from './GroupCoaching/CoachingEventPage'

export default {
  path: '/internal',
  exact: false,
  Component: WithPermission(SelfServe, ['page:internal:self_serve'], true),
  access: 'USER',
  routes: [
    {
      path: '/internal/self-serve',
      exact: true,
      Component: SelfServeWidgets,
      access: 'USER',
    },
    {
      path: '/internal/self-serve/funder-shared-goals',
      exact: true,
      Component: FunderSharedGoals,
      access: 'USER',
    },
    {
      path: '/internal/self-serve/impact-report',
      exact: true,
      Component: ImpactReport,
      access: 'USER',
    },
    {
      path: '/internal/self-serve/impact-report-dashboard',
      exact: true,
      Component: ImpactReportDashboard,
      access: 'USER',
    },
    {
      path: '/internal/self-serve/needs-assessment/trigger-new-surveys',
      exact: true,
      Component: NeedsAssessmentTrigger,
      access: 'USER',
    },
    {
      path: '/internal/self-serve/funder-report',
      exact: true,
      Component: FunderReport,
      access: 'USER',
    },
    {
      path: '/internal/self-serve/check-in-survey',
      exact: true,
      Component: CheckInSurvey,
      access: 'USER',
    },
    {
      path: '/internal/self-serve/goals-wizard',
      exact: true,
      Component: GoalsWizard,
      access: 'USER',
    },
    {
      path: '/internal/self-serve/impersonate',
      exact: true,
      Component: Impersonate,
      access: 'USER',
    },
    {
      path: '/internal/self-serve/coaching-event-management',
      exact: true,
      Component: CoachingEventPage,
      access: 'USER',
    },
  ],
}
